import { ModalDialog } from 'foundations-components/transitional/components/ModalDialog';
import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { WizardPage } from '../features/wizard';
import { jsx as _jsx } from "react/jsx-runtime";
const Wizard = () => {
  // Use <UIModal> below if we decide to reintroduce modal animation
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FullScreen, {
      children: /*#__PURE__*/_jsx(ModalDialog, {
        "data-test-id": "wizard-modal",
        use: 'fullscreen',
        children: /*#__PURE__*/_jsx(WizardPage, {})
      })
    })
  });
};
export default Wizard;